// src/services/authService.js
const API_URL = process.env.REACT_APP_API_URL;

// src/services/authService.js
export const authService = {
  authenticatedFetch: async (endpoint, options = {}) => {
    const accessToken = localStorage.getItem('accessToken');
    
    console.log('[AuthService - Request]', { 
      endpoint,
      hasToken: !!accessToken
    });
    
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken ? { 'Authorization': `Bearer ${accessToken}` } : {}),
        ...(options.headers || {})
      }
    };

    try {
      let response = await fetch(`${API_URL}${endpoint}`, {
        ...defaultOptions,
        ...options,
        headers: {
          ...defaultOptions.headers,
          ...(options.headers || {})
        }
      });

      // If token expired, try to refresh
      if (response.status === 401) {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          // No refresh token, need to login again
          window.location.href = '/login';
          return;
        }

        try {
          // Try to refresh the token
          const refreshResponse = await fetch(`${API_URL}/auth/refresh`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ refreshToken })
          });

          if (!refreshResponse.ok) {
            // Refresh failed, need to login again
            window.location.href = '/login';
            return;
          }

          const { accessToken: newAccessToken } = await refreshResponse.json();
          localStorage.setItem('accessToken', newAccessToken);

          // Retry original request with new token
          response = await fetch(`${API_URL}${endpoint}`, {
            ...defaultOptions,
            ...options,
            headers: {
              ...defaultOptions.headers,
              'Authorization': `Bearer ${newAccessToken}`,
              ...(options.headers || {})
            }
          });
        } catch (error) {
          console.error('[AuthService - Refresh Error]:', error);
          window.location.href = '/login';
          return;
        }
      }

      return response;
    } catch (error) {
      console.error('[AuthService - Fetch Error]', {
        error,
        endpoint,
        apiUrl: API_URL
      });
      throw error;
    }
  }
};